export default __webpack_public_path__ + "static/media/flow-logo.dc622c64.svg";